(function(window, angular) {
  "use strict";
  var m = angular.module("vvCommon");

  m.service('vvPage', function(vv, vvBrowser, $rootScope, gettextCatalog, vvTrack) {
    var vvPage = this;

    var getPageData = function(overridedPageData) {
      var scat = vv.getVvMetaData('scat');
      var description;
      if (scat == 'vonvon')
      description = gettextCatalog.getString('심심할 땐 봉봉!');
      else if (scat == 'wooof')
      description = gettextCatalog.getString('Bored to death? get a dog.');
      else
      description = gettextCatalog.getString('심심할 땐 봉봉!');
      var pageData = {
        'site_name': scat,
        'url': vv.getHomeUrl(),
        'title': vv.getVvMetaData('site_title'),
        'description': description,
        'image': vv.getVvMetaData('di').url,
        'image:type': vv.getVvMetaData('di').type,
        'type': 'article'
      };

      for (var key in overridedPageData) {
        pageData[key] = overridedPageData[key];
      }

      return pageData;
    };

    var resetMetaData = function(pageData) {
      for (var key in pageData)
      vv.setMetaData('og:' + key, pageData[key]);

      if (vvBrowser.isPseudoMetaEnabled()) {
        $rootScope.pageImage = pageData['pseudoImage'] || pageData['image'];
        $rootScope.pageDescription = pageData['description'];
      }
    };

    vvPage.pageLoaded = function(overridedPageData, pageForGa) {
      overridedPageData = overridedPageData || {};
      var _title = overridedPageData._title;
      delete overridedPageData._title;
      if (vvBrowser.isWeChatBuiltIn())
      _title = null;

      var pageData = getPageData(overridedPageData);
      resetMetaData(pageData);

      window.document.title = _title || pageData.title;

      vvPage.trackPageView(pageForGa, pageData.title);
    };

    vvPage.trackPageView = function(path, title) {
      vvTrack.trackPageView(path, title);
    };

    vvPage.trackPixels = function(what, params) {
      vvTrack.trackFBPixel(what, params)
      vvTrack.trackTWPixel(what, params)
    }

    var campaign = null;

    vvPage.loadCampaign = function() {
      vvTrack.loadCampaign();
    };

    vvPage.getCampaign = function() {
      return vvTrack.getCampaign();
    };

    vvPage.setBodyColorByClass = function(small, medium, large) {
      $rootScope.content_style = {};
      vv.$('body').removeClass('small-white small-gray').addClass('small-' + small)
      .removeClass('medium-white medium-gray').addClass('medium-' + medium)
      .removeClass('large-white large-gray').addClass('large-' + large);
    };

    vvPage.setBodyColorByCode = function(bgColor) {
      bgColor = bgColor || '';
      var colorCode = null;
      var matched = bgColor.match(/^#?([0-9a-f]+)/i);
      if (matched) {
        colorCode = '#'+ matched[1];
      }
      if (colorCode != null) {
        $rootScope.content_style = {
          background: colorCode
        };
      }
    };

    vvPage.resetBodyColor = function() {
      vvPage.setBodyColorByClass('white', 'white', 'white');
      $rootScope.content_style = {};
    };
  });

  m.run(function(vvPage) {
    vvPage.loadCampaign();
  });
})(window, window.angular);
